export default "__VITE_ASSET__Baq30mcz__"